import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { UserListActionsColumn } from '@app/feature/user/user-list/user-list-actions.column';
import { UserListEmailAddressColumn } from '@app/feature/user/user-list/user-list-email-address.column';
import { UserListFirstNameColumn } from '@app/feature/user/user-list/user-list-first-name.column';
import { UserListLastNameColumn } from '@app/feature/user/user-list/user-list-last-name.column';
import { UserListRolesColumn } from '@app/feature/user/user-list/user-list-roles.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const networkUserListColumnHelper =
  createColumnHelper<GatewayUserModel>();

type ResourceColumnType = ColumnDef<GatewayUserModel, any>[];

export const NETWORK_USER_LIST_COLUMN_LIST: ResourceColumnType = [
  networkUserListColumnHelper.accessor('firstName', UserListFirstNameColumn),
  networkUserListColumnHelper.accessor('lastName', UserListLastNameColumn),
  networkUserListColumnHelper.accessor(
    'emailAddress',
    UserListEmailAddressColumn,
  ),
  networkUserListColumnHelper.accessor('roles', UserListRolesColumn),
  networkUserListColumnHelper.display(UserListActionsColumn),
];

export const NETWORK_USER_LIST_COLUMN_ID_LIST =
  NETWORK_USER_LIST_COLUMN_LIST.flatMap((columnDef) => {
    if ('accessorKey' in columnDef) {
      return [columnDef.id ?? (columnDef.accessorKey as string)];
    }

    if (columnDef.id) {
      return [columnDef.id];
    }

    return [];
  });

export const NETWORK_USER_LIST_COLUMN_ORDER = [
  ...NETWORK_USER_LIST_COLUMN_ID_LIST,
];

export const NETWORK_USER_LIST_COLUMN_VISIBILITY =
  NETWORK_USER_LIST_COLUMN_ID_LIST.reduce((columnVisibility, columnId) => {
    return { ...columnVisibility, [columnId]: true };
  }, {});
